// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nv-9";
export var arrowButtonContainer = "_nv-5";
export var arrowButtonIcon = "_nv-6";
export var carouselArrowButton = "_nv-2";
export var carouselElementContainer = "_nv-1";
export var currentSlide = "_nv-8";
export var left = "_nv-3";
export var otherSlide = "_nv-a";
export var productCarouselContainer = "_nv-0";
export var right = "_nv-4";
export var sliderOverflow = "_nv-7";